// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IWhw","content":"styles_content__3oE3a","row":"styles_row__n91hO","footer":"styles_footer__1jEjx","phraseLength":"styles_phraseLength__3JKtd"};